<div class="feedback" (click)="openFeedbackDialog()">
    <span>
      feedback
    </span>
</div>